<template>
  <div class="match-card-div">

    <div :key="match.serverId" class="match-card"
         @click="goToMatch(match.serverId)">
      <img v-if="match.images && match.images.length > 0" :src="getFileUrl(match.images[0].fileUrl)"
           alt="Image de l'match" class="card-img">
      <img v-else :src="require(`@/assets/images/b122/PLACEHOLDER.png`)" alt="Image du match" class="card-img">
      <div class="body-match">
        <div>
          <i v-for="index in 5" :class="(index <= match.additionnalRewardLevel ? 'ph-star-fill' : 'ph-star') + ' main-color'"></i>
        </div>
        <div class="card-title-match vehicle-name">{{ match.title }}</div>

        <div class="d-flex align-items-center mt-2">
          <i class="ph-custom ph-clock-counter-clockwise main-color"/>
          <span class="relative-date ml-2">{{ convertTimestampToRelativeDate(match.annonceDate) }}</span>
        </div>

        <div class="d-flex align-items-center mb-lg-0 w-100 mt-2">
          <i class="ph-custom ph-map-trifold main-color"/>
          <span class="relative-date ml-2">{{ getLocation(match.theftPosition) }}</span>
        </div>
      </div>

      <div class="not-seen-annonce view-label" >
        <div><span class="ml-1">{{ match.annonceNbViews ? match.annonceNbViews : '0' }}</span></div>
        <svg class="mr-1" fill="none" height="19" viewBox="0 0 19 19" width="19" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.1595 9.27219C18.1349 9.21664 17.5393 7.89547 16.2153 6.57148C14.4512 4.80734 12.223 3.875 9.7705 3.875C7.318 3.875 5.0898 4.80734 3.32566 6.57148C2.00167 7.89547 1.40331 9.21875 1.38152 9.27219C1.34953 9.34413 1.33301 9.42198 1.33301 9.5007C1.33301 9.57943 1.34953 9.65728 1.38152 9.72922C1.40613 9.78477 2.00167 11.1052 3.32566 12.4292C5.0898 14.1927 7.318 15.125 9.7705 15.125C12.223 15.125 14.4512 14.1927 16.2153 12.4292C17.5393 11.1052 18.1349 9.78477 18.1595 9.72922C18.1915 9.65728 18.208 9.57943 18.208 9.5007C18.208 9.42198 18.1915 9.34413 18.1595 9.27219ZM9.7705 12.3125C9.21424 12.3125 8.67047 12.1475 8.20796 11.8385C7.74545 11.5295 7.38496 11.0902 7.17209 10.5763C6.95922 10.0624 6.90352 9.49688 7.01204 8.95131C7.12056 8.40574 7.38843 7.9046 7.78176 7.51126C8.1751 7.11793 8.67624 6.85006 9.22181 6.74154C9.76738 6.63302 10.3329 6.68872 10.8468 6.90159C11.3607 7.11446 11.8 7.47495 12.109 7.93746C12.4181 8.39997 12.583 8.94374 12.583 9.5C12.583 10.2459 12.2867 10.9613 11.7592 11.4887C11.2318 12.0162 10.5164 12.3125 9.7705 12.3125Z"
            fill="black"/>
        </svg>
      </div>
    </div>

    <div class="match-infos">

      <div class="match-info">
        <i class="ph-custom ph-eye-fill main-color"/> {{$t('my.matches.vehicle.matched.at')}}{{convertTimestampToFormatedDate(match.date)}}
      </div>

      <div class="match-info">
        <i class="ph-custom ph-map-pin-fill main-color"/> {{match.address}}
      </div>

      <div class="match-info" v-if="match.status === 'FINISHED'">
        <i class="ph-custom ph-check-circle-fill validated-color"/> {{$t('my.matches.vehicle.restitued')}}{{match.restitutionDate ? $t('my.matches.the') + convertTimestampToFormatedDate(match.restitutionDate) : ''}}
      </div>
      <div class="match-info" v-if="match.status === 'FINISHED'">
        <i class="ph-custom ph-coins-fill validated-color"/> {{match.moneyGained}}{{match.moneyGained > 1 ? $t('my.matches.money.gained.s') : $t('my.matches.money.gained')}}
      </div>
      <div class="match-info" v-if="match.status === 'FINISHED'">
        <i class="ph-custom ph-coins-fill validated-color"/> {{match.lampionsGained}} {{match.lampionsGained > 1 ? $t('my.matches.lampion.gained.s') : $t('my.matches.lampion.gained')}}
      </div>
      <div class="match-info" v-else-if="match.status === 'REFUSED' || match.status === 'INVALID'">
        <i class="ph-custom ph-x-circle-fill refused-color"/> {{$t('my.matches.match.refused')}}
      </div>
      <div class="match-info" v-else>
        <i class="ph-custom ph-hourglass-high-fill hourglass-color"/> {{$t('my.matches.to.be.validated')}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MatchCardImage",
  props: {
    match: {
      default: null,
      type: Object,
      required: true
    }
  },

  methods: {
    getFileUrl(path) {
      return (window.location.hostname === "integration-grand-public-lamp.bleu122.com" ? "https://integration-lamp.bleu122.com" : process.env.SERVER_URL) + path
    },
    convertTimestampToFormatedDate(timestamp) {
      const mois = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ];

      const date = new Date(timestamp);

      const jour = date.getDate();
      const moisNom = mois[date.getMonth()];
      const année = date.getFullYear();

      return `${jour} ${moisNom} ${année}`;
    },
    convertTimestampToRelativeDate(timestamp) {
      const currentTimestamp = Date.now();
      const diffInMs = currentTimestamp - timestamp;

      const secondsInMs = 1000;
      const minutesInMs = secondsInMs * 60;
      const hoursInMs = minutesInMs * 60;
      const daysInMs = hoursInMs * 24;
      const monthsInMs = daysInMs * 30; // Environ 30 jours par mois
      const yearsInMs = daysInMs * 365; // Environ 365 jours par an

      if (diffInMs < secondsInMs) {
        return "à l'instant";
      } else if (diffInMs < minutesInMs) {
        const secondsAgo = Math.floor(diffInMs / secondsInMs);
        return `il y a ${secondsAgo} ${secondsAgo === 1 ? 'seconde' : 'secondes'}`;
      } else if (diffInMs < hoursInMs) {
        const minutesAgo = Math.floor(diffInMs / minutesInMs);
        return `il y a ${minutesAgo} ${minutesAgo === 1 ? 'minute' : 'minutes'}`;
      } else if (diffInMs < daysInMs) {
        const hoursAgo = Math.floor(diffInMs / hoursInMs);
        return `il y a ${hoursAgo} ${hoursAgo === 1 ? 'heure' : 'heures'}`;
      } else if (diffInMs < monthsInMs) {
        const daysAgo = Math.floor(diffInMs / daysInMs);
        return `il y a ${daysAgo} ${daysAgo === 1 ? 'jour' : 'jours'}`;
      } else if (diffInMs < yearsInMs) {
        const monthsAgo = Math.floor(diffInMs / monthsInMs);
        return `il y a ${monthsAgo} ${monthsAgo === 1 ? 'mois' : 'mois'}`;
      } else {
        const yearsAgo = Math.floor(diffInMs / yearsInMs);
        return `il y a ${yearsAgo} ${yearsAgo === 1 ? 'an' : 'ans'}`;
      }
    },
    getLocation(pos) {
      if (pos && pos.departement) {
        return pos.departement
      }
      return 'Non renseigné'
    }
  }

}
</script>

<style scoped>

.match-card-div {
  width: 800px;
  height: 162px;
  border-radius: 10px;
  border: 1px solid var(--main-black-dark);
  display: flex;
}

.match-card {
  position: relative;
  display: flex;
  gap: 8px;
  min-width: 395px;
  border-radius: 10px;
  background-color: var(--main-black-dark);
}

.match-infos {
  flex-grow: 2;
  display: flex;
  gap: 4px;
  flex-direction: column;
  justify-content: center;
}

.match-info {
  margin-left: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--main-grey-medium);

}

.card-img {
  object-fit: cover;
  width: 142px;
  height: 142px;
  border-radius: var(--sixth-border-radius);
}

.card-title-match {
  font-size: 15px;
}


@media (max-width: 768px) {

  .card-title-match {
    font-size: 14px;
  }

  .relative-date {
    min-width: 80px;
  }

  .view-label-others {
    padding: 1px 3px;
    min-width: 60px !important;
    font-size: 10px;
  }
}

.match-card {
  padding: 10px;
  border-radius: var(--fourth-border-radius);
}

.matchs .card {
  display: flex;
  align-items: center;
}


.match-card .card-body {
  flex-grow: 1;
}


.body-match {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}


.relative-date {
  color: var(--main-grey-medium);
  font-size: 14px;
  display: flex;
  align-items: center;
  min-width: 100px;
}

.vehicle-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  box-sizing: border-box;
  word-break: break-word;
}

.view-label {
  position: absolute;
  right: 0px;
  bottom: 10px;
  padding: 2px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 80px;
  height: 31px;
  border-radius: 2.5px 0 0 2.5px;
  color: var(--main-black-dark);
  font-weight: 700;
}

.not-seen-annonce {
  background: var(--main-yellow-medium);
}

.seen-annonce {
  background: var(--main-grey-light);
}

.hourglass-color {
  color: var(--main-yellow-darker);
}

.validated-color {
  color: var(--main-green-medium);
}

.refused-color {
  color: var(--main-red-medium);
}

</style>



// WEBPACK FOOTER //
// src/components/annonce/MatchesCardImage.vue